import { lazy } from "react";

import * as Auth from "./auth";
import * as Layout from "./layout";
import * as Payments from "./payments";
import * as Common from "./common";

const Loading = lazy(() => import("./loading"));
const DraftPostsModal = lazy(() => import("./draft-posts-modal"));
const GlobalLoader = lazy(() => import("./global-loader"));
const ScheduleSettingsModal = lazy(() => import("./editor/schedule-settings-modal"));
const ViewPostModal = lazy(() => import("./view-post-modal"));
const SchedulePostModal = lazy(() => import("./editor/schedule-post-modal"));
const Notification = lazy(() => import("./notification"));
const DatePickerWithTimezone = lazy(() => import("./date-picker-with-timezone"));
const PublishPostModal = lazy(() => import("./editor/publish-post-modal"));
const DeleteConfirmationModal = lazy(() => import("./delete-confirmation-modal"));
const Editor = lazy(() => import("./editor/editor"));
const EditPostSidePanelOverlay = lazy(() => import("./edit-post-side-panel-overlay"));
const DateInUserTimezone = lazy(() => import("./date-in-user-timezone"));
const DateFromTimeSlotInstance = lazy(() => import("./date-from-time-slot-instance"));
const DateTimeFromTimeSlotInstance = lazy(() => import("./datetime-from-time-slot-instance"));
const AutoScrollingTextarea = lazy(() => import("./auto-scrolling-textarea"));
const SuggestionsSidebar = lazy(() => import("./editor/suggestions-sidebar"));
const PostGenerationFromTemplate = lazy(() => import("./post-generation-from-template"));
const StyleSelectionModal = lazy(() => import("./style-selection-modal"));
const PostFileView = lazy(() => import("./post-file-view"));
const ContentGenerationFeedbackWidget = lazy(() => import("./content-generation-feedback-widget"));
const CarouselView = lazy(() => import("./carousel-view"));
const InvoiceTable = lazy(() => import("./invoice-table"));


export {
  Loading,
  DraftPostsModal,
  GlobalLoader,
  ScheduleSettingsModal,
  ViewPostModal,
  SchedulePostModal,
  Notification,
  DatePickerWithTimezone,
  PublishPostModal,
  DeleteConfirmationModal,
  Editor,
  SuggestionsSidebar,
  EditPostSidePanelOverlay,
  DateInUserTimezone,
  DateTimeFromTimeSlotInstance,
  AutoScrollingTextarea,
  PostGenerationFromTemplate,
  StyleSelectionModal,
  PostFileView,
  ContentGenerationFeedbackWidget,
  Auth,
  Layout,
  Payments,
  Common,
  CarouselView,
  DateFromTimeSlotInstance,
  InvoiceTable
};
